var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"capital-filter"}},_vm._l((_vm.capitals),function(capital,index){return _c('button',{key:index,staticClass:"ui button",class:{ chosen: capital === _vm.chosen, unchosen: capital !== _vm.chosen },on:{"click":function($event){return _vm.updateCapital(capital)}}},[_vm._v("\n    "+_vm._s(capital)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38565db6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CapitalFilter.vue
// module id = 512
// module chunks = 0